module.exports = __webpack_public_path__ + "66d9efffbc7e558862f6c00247901456.pdf";